module.exports = __webpack_public_path__ + "img/plate_photo_1.388c9132.jpg";